import type { EbookBookTemplateState, EbookBookTemplateAction } from '@orientaction/types';

const INITIAL_STATE: EbookBookTemplateState = {
  values: {
    title: '',
    couvTemp: '',
  },
};

const ebookBookTemplateReducer = (
  state: EbookBookTemplateState = INITIAL_STATE,
  action: EbookBookTemplateAction,
): EbookBookTemplateState => {
  switch (action.type) {
    case 'UPDATE_FIELD_EBOOK': {
      const { field, value } = action.payload as { field: string; value: any };
      return {
        ...state,
        values: { ...state.values, [field]: value },
      };
    }

    case 'SET_ALL_VALUES_EBOOK':
      return {
        ...state,
        values: {
          ...state.values,
          ...(action.payload as Record<string, any>),
        },
      };

    case 'RESET_VALUES_EBOOK':
      return {
        values: {
          title: '',
          couvTemp: '',
        },
      };

    default:
      return state;
  }
};

export default ebookBookTemplateReducer;
